import { RiskTolerance, TimeHorizon } from "@tastyworks/tastyworks-api"
import { object, string } from "yup"

export const riskToleranceSchema = object({
  riskTolerance: string().oneOf(Object.values(RiskTolerance)).required(),
})

export const investmentTimeHorizonSchema = object({
  investmentTimeHorizon: string().oneOf(Object.values(TimeHorizon)).required(),
})

export const businessPreferencesSchema = object({
  riskTolerance: riskToleranceSchema,
  investmentTimeHorizon: investmentTimeHorizonSchema,
})

if (import.meta.vitest) {
  const { it, expect, describe } = import.meta.vitest

  describe("businessPreferencesSchema", () => {
    describe("riskToleranceSchema", () => {
      it("validates valid risk tolerance values", () => {
        expect(
          riskToleranceSchema.isValidSync({
            riskTolerance: RiskTolerance.LOW,
          })
        ).toBe(true)
      })

      it("rejects invalid values", () => {
        expect(
          riskToleranceSchema.isValidSync({ riskTolerance: "invalid" })
        ).toBe(false)
      })

      it("requires riskTolerance field", () => {
        expect(riskToleranceSchema.isValidSync({})).toBe(false)
      })
    })

    describe("investmentTimeHorizonSchema", () => {
      it("validates valid time horizon values", () => {
        expect(
          investmentTimeHorizonSchema.isValidSync({
            investmentTimeHorizon: TimeHorizon.SHORT,
          })
        ).toBe(true)
      })

      it("rejects invalid values", () => {
        expect(
          investmentTimeHorizonSchema.isValidSync({
            investmentTimeHorizon: "invalid",
          })
        ).toBe(false)
      })

      it("requires investmentTimeHorizon field", () => {
        expect(investmentTimeHorizonSchema.isValidSync({})).toBe(false)
      })
    })

    describe("businessPreferencesSchema", () => {
      it("validates complete business preferences", () => {
        expect(
          businessPreferencesSchema.isValidSync({
            riskTolerance: {
              riskTolerance: RiskTolerance.MEDIUM,
            },
            investmentTimeHorizon: {
              investmentTimeHorizon: TimeHorizon.AVERAGE,
            },
          })
        ).toBe(true)
      })

      it("rejects incomplete data", () => {
        expect(
          businessPreferencesSchema.isValidSync({
            riskTolerance: {
              riskTolerance: RiskTolerance.MEDIUM,
            },
          })
        ).toBe(false)
      })
    })
  })
}
